import React from "react";
import cx from "classnames";
import Button, {
  buttonTypes,
  actionTypes
} from "@bit/fabfitfun.shared.global.button";

import "./NoItemsCTA.css";

const NoItemsCTA = props => {
  const { icon, title, desc, ctaLabel, onClick, isMobile } = props;

  const styles = cx({
    mobile: isMobile,
    "ta-center": true,
    "no-items-cta": true,
    "mar-a": true
  });

  return (
    <div className={styles}>
      <i className={icon? icon : "fal fa-shopping-bag add-ons-closed-i"} />
      <h3 className="ff-ns">{title}</h3>
      <p className="description-text">{desc}</p>

      <Button
        className="case-caps"
        type={buttonTypes.CALL_TO_ACTION}
        action={actionTypes.CALL_TO_ACTION.value}
        label={ctaLabel}
        onClick={onClick}
        style={isMobile ? { width: "100%" } : {}}
      />
      <br />
    </div>
  );
};

export default NoItemsCTA;



// WEBPACK FOOTER //
// ./src/Components/Panels/SharedComponents/NoItemsCTA/NoItemsCTA.js